import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email("Gecerli bir email adresi giriniz"),
  password: z.string().min(6, "Sifre en az 6 karakter olmalidir"),
});

export type LoginInput = z.infer<typeof loginSchema>;

// Keep backward compat alias
export const mockLoginSchema = loginSchema;
export type MockLoginInput = LoginInput;

export const createUserSchema = z.object({
  email: z.string().email("Gecerli bir email adresi giriniz"),
  password: z.string().min(6, "Sifre en az 6 karakter olmalidir"),
  name: z.string().optional(),
  role: z.enum(["admin", "user"]).default("user"),
});

export type CreateUserInput = z.infer<typeof createUserSchema>;
